/**
 * This represents an error when trying to map a JQL AST to a collection of refinements supported by the component.
 * If the AST contains syntax or fields not supported by the filter refinement then this error will be thrown.
 */
export class UnsupportedRefinementErrorOld extends Error {}
